import axios from "axios";
import { createContext, useState, useEffect } from "react";
export const AuthContext = createContext({});
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import apiClient from "../libraries/ApiClient";

export const AuthProvider = function ({ children }) {
  const navigate = useNavigate();
  const [accountRowId, setAccountRowId] = useState("");
  const [token, setToken] = useState("");
  const [code, setCode] = useState(null);
  const [loginAfter, setLoginAfter] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    setAccountRowId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
  }, []);
  const unAuth = {
    authorized: false,
    AccountRowId: "",
    Name: "",
    Account: "",
    Token: "",
    SelfIdentities: [],
    OtherIdentities: [],
    Menus: [],
    Hospital: "",
    HospitalCode: "",
    IsAdmin: false,
    IsTempAccount: false,
    AccountPermission: 4,
    // IsOtherHospital: false,
  };

  let initAuth = { ...unAuth };

  const str = localStorage.getItem("auth");

  if (str) {
    const localAuth = JSON.parse(str);
    if (localAuth && localAuth.Token) {
      initAuth = { ...localAuth, authorized: true };
    }
  }

  const [myAuth, setMyAuth] = useState(initAuth);

  //   console.log(myAuth)

  const logout = async () => {
    const data = {
      Data: {
        Token: token,
        AccountRowId: accountRowId,
      },
    };
    const res = await apiClient.postAes("api/login/logout/security", data);

    localStorage.removeItem("auth");
    localStorage.removeItem("liffId");
    localStorage.removeItem("noticeData");
    localStorage.removeItem("actionUuid");
    setMyAuth(unAuth);
    setCode(null);
    navigate("/login");
    setLoginAfter("");
  };

  return (
    <AuthContext.Provider
      value={{
        myAuth,
        setMyAuth,
        logout,
        loginAfter,
        setLoginAfter,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
